import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { HeroBannerBlockProps } from '../../../components/blocks/HeroBannerBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { HeroBannerSectionContent } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<HeroBannerBlockProps> = dynamic<HeroBannerBlockProps>(
  () => import('src/components/blocks/HeroBannerBlock').then((mod) => mod.HeroBannerBlock),
);

/* istanbul ignore next */
export const transformer: Transformer<HeroBannerSectionContent, HeroBannerBlockProps> = (
  {
    _metadata,
    background_color,
    text_color_mode,
    image,
    heading,
    sub_heading,
    copy,
    button,
    tracking_title,
  },
  { pageConfig, positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    backgroundColor: background_color,
    headingIsPageTitle: positionMetadata.position === 0 && pageConfig.pageType !== 'homepage',
    images: getContentstackImagesForWidths(image.image_source.url, [360, 500, 700, 900, 1132], {
      aspectRatio: '16:9',
    }),
    imageWidth: 360,
    imageHeight: 216,
    imageAlt: image.alt_text,
    textColorMode: text_color_mode,
    headingLine1: heading.line1,
    headingLine2: heading.line2,
    ...(heading.underline.show_underline && {
      headingUnderlineColor: heading.underline.underline_color,
    }),
    subHeading: sub_heading || '',
    copy: copy || '',
    buttonBackgroundColor: button?.background_color || '',
    buttonHref: button?.url || '',
    buttonText: button?.text || '',
    buttonTextColorMode: button?.text_color || 'light',
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
